<template>
  <modal-box class="unstake-lockup-modal" :title="'Unstake in Pool'">
    <template #body>
      <div class="unstake-lockup-body">
        <p class="unstake-lockup-body__lable">Unstake Lockup</p>
        <p class="unstake-lockup-body__duration">{{ unstakeLockupDuration }}</p>

        <input-button
          v-if="!isUnstakable && isUnstakeUnlockableWithFee"
          class="unstake-lockup-body__cta"
          :size="'large'"
          :disabled="!isUnstakable && !isUnstakeUnlockableWithFee"
          @click="goToUnstake"
          >Unstake Fee {{ unlockUnstakeFee }} %
        </input-button>
        <input-button
          v-else-if="!isUnstakable"
          class="unstake-lockup-body__cta"
          :disabled="!isUnstakable"
          :size="'large'"
          @click="goToUnstake"
          >Unstake
        </input-button>
        <input-button
          v-else
          class="unstake-lockup-body__cta"
          :size="'large'"
          @click="goToUnstake"
          >Unstake
        </input-button>

        <text-link class="unstake-lockup-body__close-link" @click="closeModal"
          >Close window</text-link
        >
      </div>
    </template>
  </modal-box>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import ModalBox from "@/components/molecules/ModalBox";
import TextLink from "@/components/atoms/TextLink";
import {
  isBefore,
  isAfter,
  intervalToDuration,
  fromUnixTime,
  differenceInCalendarDays,
  addSeconds,
} from "date-fns";

export default {
  name: "SteamStakingUnstakeLockupModal",
  components: {
    InputButton,
    ModalBox,
    TextLink,
  },
  data() {
    return {
      isLoading: false,
      countDownInterval: null,
      unstakeLockupDuration: "0d 00:00:00",
      isUnstakable: false,
    };
  },
  computed: {
    unstakeLockupTime() {
      return fromUnixTime(this.withdraw.stakingPool.account.withdrawableTime);
    },
    isUnstakeLocked() {
      if (this.withdraw.stakingPool.withdrawConstrains.lockType == 0) {
        return false;
      }

      return isBefore(new Date(), this.unstakeLockupTime);
    },
    isUnstakeUnlockableWithFee() {
      return this.withdraw.stakingPool.withdrawConstrains.lockType == 2;
    },
    unlockUnstakeFee() {
      return this.withdraw.stakingPool.withdrawConstrains.unlockFee;
    },
    withdraw() {
      return this.$store.state.withdraw;
    },
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
  },
  methods: {
    goToUnstake() {
      this.$store.dispatch("openModal", "steam-staking-unstake-modal");
    },
    closeModal() {
      this.$store.dispatch("closeModal");
    },
    countdown() {
      this.countDownInterval = setInterval(() => {
        if (isAfter(new Date(), this.unstakeLockupTime)) {
          this.isUnstakable = true;
          this.unstakeLockupDuration = "0d 00:00:00";
          clearInterval(this.countDownInterval);
        } else {
          this.isUnstakable = false;
          let duration = intervalToDuration({
            start: new Date(),
            end: this.unstakeLockupTime,
          });

          let months = duration.months;

          let days = duration.days;

          if (months > 0) {
            let currentDate = new Date();
            days = differenceInCalendarDays(
              addSeconds(
                currentDate,
                this.withdraw.withdrawConstrains.withdrawInterval / 1000
              ),
              currentDate
            );
          }

          this.unstakeLockupDuration = `${days}d ${this.addLeadingZero(
            duration.hours
          )}:${this.addLeadingZero(duration.minutes)}:${this.addLeadingZero(
            duration.seconds
          )}`;
        }
      }, 1000);
    },
    addLeadingZero(number) {
      if (number < 10) {
        return `0${number}`;
      }
      return number;
    },
  },
  mounted() {
    this.countdown();
  },
  beforeDestroy() {
    clearInterval(this.countDownInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
.unstake-lockup-modal {
  padding-left: 28px;
  padding-right: 28px;
}

.unstake-lockup-body {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__lable {
    margin-bottom: 20px;
  }

  &__duration {
    margin-bottom: 40px;
  }

  &__cta {
    margin-bottom: 40px;
  }

  &__close-link {
    font-size: 1.4rem;

    @include media(pc) {
      font-size: 1.7rem;
    }
  }
}
</style>